import { QueryClient } from '@tanstack/react-query';

export const queryKeys = {
  me: ['auth', 'me'] as const,
  account: ['account'] as const,
  events: ['events'] as const,
  zoomStatus: ['zoom', 'status'] as const,
  zoomSetup: ['zoom', 'setup'] as const,
  guestAccess: ['guest', 'access'] as const,
  recallConfig: ['recall', 'config'] as const,
  whopConfig: ['whop', 'config'] as const,
  messages: ['messages'] as const,
  adminUsers: ['admin', 'users'] as const,
  adminHealth: ['admin', 'health'] as const,
  adminUsage: ['admin', 'usage'] as const,
  adminSignupCode: ['admin', 'signup-code'] as const,
  notifications: ['notifications'] as const,
  teamCoverage: ['team', 'coverage'] as const,
  moderationMessages: ['moderation', 'messages'] as const,
  moderationAnswered: ['moderation', 'answered'] as const,
  moderationPins: ['moderation', 'pins'] as const,
  moderationRuntime: ['moderation', 'runtime'] as const,
  moderationSnippets: ['moderation', 'snippets'] as const,
  moderationBuyers: (limit: number) => ['moderation', 'buyers', limit] as const,
  dataSummary: ['data', 'summary'] as const,
  dataReport: (eventId: number) => ['data', 'report', eventId] as const,
  stats: ['stats'] as const,
  statsSales: ['stats', 'sales'] as const,
  statsMentions: ['stats', 'mentions'] as const,
  avPresets: ['av', 'presets'] as const,
  curatedPeople: ['display', 'people'] as const,
};

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      staleTime: 5_000,
      refetchOnWindowFocus: false,
    },
    mutations: {
      retry: false,
    },
  },
});
